// import React, {Component} from "react";
// import storage from "utils/Storage";
// import socket from "utils/Socket";
// import { __, decode, encode, forceSatoshiFormat, fixDate, wait } from 'utils/Helper';
// import C from 'utils/Constant';

// const C_ = React.createElement;

// class inrhistory extends React.Component {
//     _isMounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             loading: true,
//             deposits: []
//         };
//     }

//     componentDidMount(){
//         this._isMounted = true;
//         socket.emit(C.inr_History);
//         socket.on(C.inr_History, data => this.makeHistory(decode(data)));
//     }

//     componentWillUnmount() {
//         this._isMounted = false;
//     }

//     makeHistory(data){
//         if(this._isMounted)
//         {
//             let array = data.deposit;
//             if(array) {
//                 array.forEach((deposit, i) => {
//                     let block = <DepositTable data={deposit} key={i}/>;
//                     this.setState(state => ({deposits: [block, ...state.deposits]}));
//                 });
//             }
//             this.setState({ loading: false });
//         }
//     }

//     render() {
//         let { loading } = this.state;
//         return(
//             <>
//                     <>
//                         <div className="table-responsive mt-2" style={{ minHeight: 460 }}>
//                             <table className="table table-hover deposit">
//                                 <thead>
//                                 <tr>
//                                     <th scope="col">Date</th>
//                                     <th scope="col">Amount</th>
//                                     <th scope="col">Status</th>
//                                     <th scope="col">Transaction</th>
//                                 </tr>
//                                 </thead>
//                                 {this.state.deposits.length > 0 &&
//                                     this.state.deposits
//                                 }
//                             </table>
//                             {loading ?
//                                 <div className="text-center" style={{ minHeight: 460 }}>
//                                        <div className="spinner-grow text-white my-3" role="status" />
//                                 </div>
//                             :
//                                 <>
//                                 {this.state.deposits.length === 0 &&
//                                     <div className="alert bg-soft-dark mt-2 w-100 font-13 text-center text-upper">
//                                         [ Your deposit list is empty ]
//                                     </div>
//                                 }
//                                 </>
//                             }
//                         </div>
//                     </>
//             </>
//         );
//     }
// }

// function DepositTable(props){
//     const { amount, status, date, trxid } = props.data;
//     return(
//             <tr>
//                 <td>{fixDate(date)}</td>
//                 <td>{forceSatoshiFormat(amount) + ' ' + __.upperCase(coin)}</td>
//                 <td>{status}</td>
//                 <td>
//                     <input className="form-control" readOnly={true} value={trxid} />
//                 </td>
//             </tr>
//     );
// }

// export default inrhistory;





import React, { useMemo } from "react";
import storage from "utils/Storage";
import { forceSatoshiFormat, fixDate } from 'utils/Helper';
import { useInrHistoryQuery } from "hooks/useWallet";

function Inrhistory() {
    const username = storage.getKey('name');
    const { data: responseData, isLoading: loading } = useInrHistoryQuery(username);

    const deposits = useMemo(() => {
        if (responseData && Array.isArray(responseData)) {
            return responseData.map(deposit => ({
                date: fixDate(deposit.date), 
                amount: forceSatoshiFormat(deposit.amount), 
                status: deposit.status,
                trxid: deposit.trxid
            }));
        }
        return [];
    }, [responseData]); 
    

    return (
        <div className="table-responsive mt-2" style={{ minHeight: 460 }}>
            {loading ? (
                <div className="text-center" style={{ minHeight: 460 }}>
                    <div className="spinner-grow text-white my-3" role="status"></div>
                </div>
            ) : deposits.length > 0 ? (
                <table className="table table-hover deposit">
                    <thead>
                        <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Status</th>
                            <th scope="col">Transaction</th>
                        </tr>
                    </thead>
                    <tbody>
                        {deposits.map((deposit, index) => (
                            <tr key={index}>
                                <td>{deposit.date}</td>
                                <td>{deposit.amount}</td>
                                <td>{deposit.status}</td>
                                <td>
                                    <input 
                                        className="form-control" 
                                        readOnly={true} 
                                        value={deposit.trxid} 
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="alert bg-soft-dark mt-2 w-100 font-13 text-center text-upper">
                    Your deposit list is empty.
                </div>
            )}
        </div>
    );
    
}

export default Inrhistory;

